module.exports = {
	status: 'ready',
	title: 'Breadcrumbs',
	notes: `
		https://www.w3.org/TR/wai-aria-practices/#breadcrumb
	`,
	context: {
		items: [
			'Start',
			'Verksamhet',
			'Flygmateriel',
		]
	}
};